module.exports = __webpack_public_path__ + "static/media/covid.2697335c.mp3";